import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export const requestKnownSwimResearch = async (knownSwimId, refresh = false) => {
  const researchKnownSwimArea = httpsCallable(functions, 'researchKnownSwimArea', { timeout: 300000 });
  const result = await researchKnownSwimArea({ knownSwimId, refresh });
  return result.data;
};
